/**
 * The locales shipped with the platform.
 *
 * To add one: create `locales/<tag>.json` with the same keys as `en.json`, add the tag here and
 * its endonym to LOCALE_NAMES. The language picker, Accept-Language negotiation and the
 * completeness test pick it up automatically.
 */
export const SUPPORTED_LOCALES = ['en', 'nl'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** Language names in their own language — never translated. */
export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  en: 'English',
  nl: 'Nederlands',
};
